import React from 'react';
import { COLORS } from '../utils/constants';

/** Inline styles for the background-image control panel. */

export const panelStyle: React.CSSProperties = {
  position: 'absolute',
  top: '16px',
  left: '16px',
  width: '240px',
  padding: '14px',
  backgroundColor: 'white',
  border: '1px solid #dfe4ea',
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  zIndex: 500
};

export const labelStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  fontSize: '12px',
  color: '#636e72',
  marginTop: '8px'
};

export const hintStyle: React.CSSProperties = { margin: '4px 0' };

export const inputStyle: React.CSSProperties = {
  padding: '6px 8px',
  border: '1px solid #dfe4ea',
  borderRadius: '4px',
  fontSize: '13px'
};

export const primaryButtonStyle: React.CSSProperties = {
  padding: '8px 12px',
  border: 'none',
  borderRadius: '4px',
  backgroundColor: COLORS.ACTION,
  color: 'white',
  cursor: 'pointer',
  fontSize: '13px'
};

export const secondaryButtonStyle: React.CSSProperties = {
  padding: '8px 12px',
  border: '1px solid #dfe4ea',
  borderRadius: '4px',
  backgroundColor: 'white',
  color: '#2d3436',
  cursor: 'pointer',
  fontSize: '13px'
};

export const iconButtonStyle: React.CSSProperties = {
  border: 'none',
  background: 'transparent',
  fontSize: '18px',
  lineHeight: 1,
  cursor: 'pointer',
  color: '#636e72'
};

export const toggleButtonStyle = (active: boolean, disabled: boolean): React.CSSProperties => ({
  flex: 1,
  padding: '8px 10px',
  border: `1px solid ${active ? COLORS.ACTION : '#dfe4ea'}`,
  borderRadius: '4px',
  backgroundColor: active ? COLORS.ACTION : 'white',
  color: active ? 'white' : '#2d3436',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.5 : 1,
  fontSize: '13px'
});
